import { useSelector } from "react-redux";
import { useApiQuery } from "./useApiQuery";
import type { AppAuthState } from "../Redux/AppAuthReducer";
import { useResource } from "../Resources/useResource";
import { ProfileMenuResources } from "../Resources/ProfileMenuResources";
import { PicoAppEnum } from "jadro-pico/apps/PicoAppEnum";
import { PicoRoleEnum } from "jadro-pico/enums/auth/PicoRoleEnum";
import { ApiPaths } from "jadro-pico/api-endpoints/ApiPaths";
import type { ApiResponse } from "jadro-pico/dtos/common/ApiResponse";
import type { RacerProfileDto } from "jadro-pico/dtos/beerrally/RacerProfileDto";

const RACER_PROFILE_QUERY_KEY = ["profile", "mine"] as const;

export function useRacerProfileSubtitle(): string | undefined {
  const resources = useResource(ProfileMenuResources);
  const user = useSelector((s: { auth: AppAuthState }) => s.auth.user);
  const isRacer = user
    ? (user.resource_access?.[PicoAppEnum.BEERRALLY_PICO]?.roles ?? []).includes(PicoRoleEnum.USER)
    : false;

  const url = `${import.meta.env.VITE_PICO_API_URL}${ApiPaths.beerrally.profile.prefix}${ApiPaths.beerrally.profile.me}`;

  const { data } = useApiQuery<ApiResponse<RacerProfileDto>>({
    url,
    queryKey: RACER_PROFILE_QUERY_KEY,
    enabled: isRacer,
    retry: false,
  });

  if (!isRacer) return undefined;

  const profile = data?.data;
  return profile?.team
    ? [profile.team, profile.licence].filter(Boolean).join(" · ")
    : resources.position;
}
